import * as React from 'react';
import { TileLayout } from '@progress/kendo-react-layout';
import { RoutesTable } from '../components/routes/RoutesTable.jsx' 


export const RoutesT = () => {

   const [data, setData] = React.useState([
     {
       col: 1,
       colSpan: 4,
       rowSpan: 2,
     }
   ]);
   const tiles = [
     {
       header: 'Routes',
       body: <RoutesTable/>,
     }
   ];
   const handleReposition = (e) => {
     setData(e.value);
   };
   return (
     <TileLayout
       columns={4}
       rowHeight={400}
       positions={data}
       gap={{
         rows: 10,
         columns: 10,
       }}
       items={tiles}
       onReposition={handleReposition}
     />
   );
 };